@use "foundation/_colors.scss";

.panel {
  position: relative;
  color: colors.$primary-text-color;
  padding: 2em;
  width: auto;
  height: auto;
  background-color: rgba(255, 255, 255, 0.95);
  border: 1px solid colors.$primary-text-color;
  z-index: 2;
}

@media (max-height: 800px) {
  .panel {
    transform: scale(0.75);
    transform-origin: top left;
  }
}

.button-margin {
  margin-left: 1em !important;
}

.review-step {
  font-weight: 500;
  font-size: 1.125em;
  line-height: 1.5;
}
